namespace Permissions {
    export enum DashboardSection {
        Dashboard = 'adm_dashboard_p',
    }

    export enum UsersSection {
        Users = 'adm_user_p',
    }

    //TODO CHECK permissions
    export enum ApiServicesSection {
        ApiServices = 'adm_dashboard_p',
    }

    export enum MissionSection {
        Mission = 'adm_dashboard_p',
    }

    export enum DetectorSection {
        Detector = 'adm_dashboard_p',
    }

    export enum AirDefenseSection {
        Observation = 'adm_dashboard_p',
    }

    export enum FireDamageSection {
        FireDamage = 'adm_dashboard_p'
    }

    export enum ShellingSection {
        Shelling = 'adm_dashboard_p'
    }
    
    export enum MilitarySurveillanceSection {
        MilitarySurveillance = 'adm_dashboard_p'
    }

    export enum CrowdsourceSection {
        ThreatMonitor = 'adm_dashboard_p'
    }

    export enum UnmannedAerialVehiclesSection {
        Use_of_UAVs = 'adm_dashboard_p',
    }

    export enum MoralPsychologicalSupportSection {
        Survey = 'adm_dashboard_p',
    }

    export enum AdministrationSection {
        Admins = 'adm_adm_l',
        Roles = 'adm_role_l',
        DataEntry = 'adm_adm_l',
        Settings = 'adm_adm_l',
        Weapon = 'adm_adm_l',
        Users = 'adm_adm_l',
    }

    export enum SettingSection {
        Emplacement = 'adm_adm_l',
        Unit = 'adm_adm_l',
    }
}

export default Permissions;
